module.exports = __webpack_public_path__ + "img/fono-servicios.35330c68.png";